// import celerity from './Celerity.json';
// import fortitude from './Fortitude.json';
// import might from './Might.json';
// import sorcery from './Sorcery.json';
// import sustenance from './Sustenance.json';
import Branches from './Branches.json';

export default Branches;
